import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import moment from 'moment';
import md5 from 'md5';
import Gantt from './Gantt';
import Toolbar from './Toolbar';
import TemplateModal from './TemplateModal';
import HolderModal from './HolderModal';
import CompanyModal from './CompanyModal';
import EditCompanyModal from './EditCompanyModal';
import AddTaskModal from './AddTaskModal';
import EditTaskModal from './EditTaskModal';
// import './plan.css'
import WorkdocStore from '../../../stores/WorkdocStore';
import {momentHelper} from '../../../utils/helpers';
import {Box} from 'reactjs-admin-lte';
import * as _ from 'lodash';
import PrintModal from './PrintModal';
// import uuid from 'uuid-by-string';

const uuid = t => t;
const data = {
  data: [
    {
      id: 1,
      text: 'Project #2',
      start_date: '01-04-2013',
      duration: 18,
      order: 10,
      progress: 0.4,
      open: true,
    },
    {
      id: 2, text: 'Task #1', start_date: '02-04-2013', duration: 8, order: 10,
      progress: 0.6, parent: 1,
    },
    {
      id: 3, text: 'Task #2', start_date: '11-04-2013', duration: 8, order: 20,
      progress: 0.6, parent: 1,
    },
  ],
  links: [
    {id: 1, source: 1, target: 2, type: '1'},
    {id: 2, source: 2, target: 3, type: '0'},
  ],
};

class Plan extends Component {
  /*  state = {
     currentZoom: 'Days',
     workdocFixingPlanList: [],
     messages: [],
     task: [],
     links: [],
     task_template: [],
     holders: [],
     showTemplateModal: false,
     showHolderModal: false,
     showCompanyModal: false,
     showEditCompanyModal: false,
     companyDetails: {},
     pageMounted: true,
     view: RESPONSIBLE_NAME_VIEW
   } */
  ganttInstance;

  constructor(props) {
    super(props);
    const taskModal = {
      // newTask: {},
      latestSelectedId: '',
      // children: [],
      newTask: {},
      bf_task_id: '',
      employee_id: '',
      contractor_id: '',
      work_no: '',
      companyView: {
        company: '',
        car_registration_no: '',
        responsible_name: '',
        taskValue: '',
        taskName: '',
        taskStatus: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
      },
      workerView: {
        company: '',
        car_registration_no: '',
        responsible_name: '',
        taskValue: '',
        taskName: '',
        taskStatus: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
      },
    };
    let addTaskModal = {...taskModal};
    let editTaskModal = {...taskModal};
    editTaskModal.selectedTask = {};
    addTaskModal.newTask = {};
    this.emptyAddTaskModal = JSON.parse(JSON.stringify(addTaskModal));
    this.emptyEditTaskModal = JSON.parse(JSON.stringify(editTaskModal));

    this.state = {
      loading: false,
      currentZoom: 'Days',
      workdocFixingPlanList: [],
      workState: [],
      messages: [],
      task: [],
      links: [],
      task_template: [],
      holders: [],
      showTemplateModal: false,
      showHolderModal: false,
      showCompanyModal: false,
      showEditCompanyModal: false,
      showPrintModal: false,
      showAddTaskModal: false,
      showEditTaskModal: false,
      companyDetails: {},
      pageMounted: true,
      maxLevel: 3,
      newTask: {},
      addTaskModal: addTaskModal,
      editTaskModal: editTaskModal,

      /**
       * Paging
       */
      page: 1,
      page_num: 1,
      page_limit: 5,
      page_prev: false,
      page_next: false,
      keyword: '',
      data: [],
      filter_ids: [],

      filter_date: {
        start_date: moment().startOf('year').format('YYYY-MM-DD'),
        end_date: moment().endOf('year').format('YYYY-MM-DD'),
      },
    };
  }

  componentDidMount() {
    this.setState({loading: true},
        () => this.updatePlanState(this.props),
    );
  }

  componentWillReceiveProps(nextProps) {
    this.gantt.clearAll();
    this.setState({loading: true}, () => this.updatePlanState(nextProps));
  }

  getTaskColor = (status) => {
    return new Promise((resolve, reject) => {
    });
  };

  sortTaskList(theTaskList, work_state) {
    return work_state.reduce((acc, eachWorkState) => {
      const workOfThisState =
          theTaskList.filter((eachTask) => eachTask.tasklist[0].taskValue ===
                                           eachWorkState.value);
      return workOfThisState.length > 0
          ? acc.concat(workOfThisState[0])
          : acc;
    }, []);
  }

  sortDataByWorkState(data, work_state) {
    data.forEach((ele) => {
      ele.worklist.forEach((wl) => {
        wl.tasklist = this.sortTaskList(wl.tasklist, work_state);
      });
    });
  }

  createGanttDataByCompany = async (data, work_state) => {
    // this.sortDataByWorkState(data, work_state)
    let finalData = [];
    let companyData = [];
    const normalizeData = await Promise.all(
        data.map(async (d, index) => {
          const {worklist, company} = d;
          let taskData = [];
          const lvl_0_id = company;
          const companyTask = {
            id: lvl_0_id, isCompany: true, name: company, $level: 0,
            start_date: '', duration: '',
            unscheduled: true,
            // start_date: moment().format('DD-MM-YYYY'), duration: 0, progress: 0
          };
          let company_date = {start_date: [], end_date: []};
          let allCarTasks = [];
          const carTask = await Promise.all(
              worklist.map(async (c) => {
                const lvl_1_id = [lvl_0_id, c.work_no].join('-');
                const car = {
                  id: lvl_1_id,
                  name: c.car_registration_no,
                  $level: 1,
                  parent: lvl_0_id,
                  start_date: '',
                  duration: '',
                  unscheduled: true,
                  // start_date: moment().format('DD-MM-YYYY'), duration: 0, progress: 0
                };
                let car_date = {start_date: [], end_date: []};
                const {tasklist} = c;
                const taskOfCar = await Promise.all(
                    tasklist.map(async (t) => {
                      const lvl_2_id = [
                        lvl_1_id,
                        `${t.responsible_name}${c.car_registration_no}`].join(
                          '-');
                      const level1Task = {
                        id: lvl_2_id,
                        // id: `${t.bf_task_id}`,
                        name: t.responsible_name,
                        $level: 2,
                        parent: lvl_1_id,
                        start_date: '',
                        duration: '',
                        unscheduled: true,
                        // start_date: moment(t.startDate).format('DD-MM-YYYY'), duration: t.duration, progress: 0
                      };
                      const {tasklist} = t;
                      const level2Task = await Promise.all(
                          tasklist.map(l2 => {
                            let taskColor = 'orange';
                            switch (l2.taskStatus) {
                              case '0':
                                taskColor = 'grey';
                                break;
                              case '1':
                                taskColor = 'orange';
                                break;
                              case '2':
                                taskColor = 'blue';
                                break;
                              case '3':
                                taskColor = 'red';
                                break;
                              default:
                                break;
                            }
                            let start_date_text = l2.startDate
                                ? moment(l2.startDate, 'DD/MM/YYYY').
                                    format('DD-MM-YYYY')
                                : '';
                            let end_date_text = l2.endDate
                                ? moment(l2.endDate, 'DD/MM/YYYY').
                                    format('DD-MM-YYYY')
                                : '';
                            let now = moment().format('DD-MM-YYYY');

                            const disabled = !start_date_text && !end_date_text;
                            const lvl_3_id = [
                              lvl_2_id,
                              `${l2.taskName}${t.bf_task_id}`].join('-');
                            const microTask = {
                              disabled,
                              id: lvl_3_id,
                              bf_task_id: `${t.bf_task_id}`,
                              name: l2.taskName,
                              $level: 3,
                              parent: lvl_2_id,
                              color: taskColor,
                              start_date: '',
                              end_date: '',
                              duration: 0,
                              unscheduled: disabled,
                            };
                            if (!disabled) {
                              microTask.start_date = start_date_text ||
                                                     end_date_text;
                              microTask.end_date = end_date_text ||
                                                   start_date_text;
                              microTask.duration = l2.duration || '';
                              microTask.progress = 0;
                            }
                            return microTask;
                          }),
                      );
                      const data = [level1Task, ...level2Task];
                      allCarTasks = [...allCarTasks, ...data];

                      return;
                    }),
                );
                return [car, ...allCarTasks];
              }),
          );

          finalData = [...finalData, ...carTask];
          companyData = [...companyData, companyTask];
          return;
        }),
    );
    let tasks = [];
    const combineTasks = await finalData.map((d) => {
      tasks = [...tasks, ...d];
    });
    const combineCompany = await companyData.map(c => {
      tasks = [...tasks, c];
    });
    tasks = tasks.filter(task => task != undefined);
    const uniqueTasks = tasks.reduce((acc, thisTask) => {
      const ids = acc.length > 0
          ? acc.map((ele) => ele.id)
          : null;
      if (ids === null) return acc.concat(thisTask);
      if (ids.indexOf(thisTask.id) === -1) return acc.concat(thisTask);
      return acc;
    }, []);
    const links = this.createLinks(uniqueTasks, work_state);
    // console.log('tasks by customers', JSON.parse(JSON.stringify(tasks)))
    // console.log('createLinks', this.createLinks(uniqueTasks))
    this.setState({
          workdocFixingPlanList: data,
          workState: work_state,
          task: uniqueTasks,
          links: links,
          maxLevel: 3,
          loading: false,
        },
        () => this.applyFilter(),
    );
  };

  // const nextWorkStateIndex =
  //   arr.findIndex((e) => idx + 1 < arr.length && e.name === workState[idx + 1].label)

  // console.log('t name', t.name)
  // const wIndex = workState.findIndex((w) => w.label === t.name)
  // const nextTaskIndex =
  //   arr.findIndex((tk) => (wIndex + 1 < arr.length && tk.name === workState[wIndex + 1].label))

  // return {
  //   id: t.parent + idx,
  //   source: t.id,
  //   target:
  //     (
  //       idx < arr.length - 1
  //       && nextTaskIndex !== -1
  //     )
  //       ? arr[idx + 1].id
  //       : ''
  //   ,
  //   type: '0'
  // }

  createGroupsOfLinks(tasks, workState) {
    const parents = tasks.filter((t) => t.$level === this.state.maxLevel - 1);
    // return array of group of tasks of given parent id
    return parents.map((p) => {
      const microTasks = tasks.filter((t) =>
          t.$level === this.state.maxLevel && t.parent === p.id,
      );

      microTasks.sort((a, b) => {
        const aIdx = workState.findIndex((w) => w.label === a.name);
        const bIdx = workState.findIndex((w) => w.label === b.name);
        return aIdx - bIdx;
      });

      return microTasks.map((t, idx, arr) => {
        const wIndex = workState.findIndex((w) => w.label === t.name);
        const isLink =
            wIndex + 1 < workState.length
            && idx < arr.length - 1
            && workState[wIndex + 1].label === arr[idx + 1].name;

        return {
          id: t.parent + idx,
          source: t.id,
          target: isLink
              ? arr[idx + 1].id
              : ''
          ,
          type: '0',
        };
      });
    });
  }

  createLinks(tasks, workState) {
    const groupsOfLinks = this.createGroupsOfLinks(tasks, workState);
    return [].concat.apply([], groupsOfLinks);
  }

  getData = async () => {
    try {
      const {data, work_state} = await WorkdocStore.loadWorkdocFixingPlanList();
      // console.log(tasks, 'tasks from fuck')
      // const links = await axios.get('/link')
      // const templates = await axios.get('/template')
      // const holders = await axios.get('/holder')
      // const sample = {id: 3, name: 'Task #2',holder:'test',$level:3,parent:2, start_date: '18-04-2017', duration: 3, progress: 0.4}

      this.createGanttDataByCompany(data, work_state);
      // this.setState({ task: tasks.data, links: links.data, task_template: templates.data, holders: holders.data, pageMounted: true })
    } catch (err) {
      console.error(err, 'error from getData');
    }
  };

  createPersonTask(taskId, level, parent, eachTask) {
    const start_date_text = eachTask.startDate ?
        moment(eachTask.startDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
        : moment().format('DD-MM-YYYY');
    const end_date_text = eachTask.endDate ?
        moment(eachTask.endDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
        : moment().format('DD-MM-YYYY');
    const disabled = !start_date_text && !end_date_text;

    if (level === 2) {
      let taskColor = 'orange';
      switch (eachTask.taskStatus) {
        case '0':
          taskColor = 'grey';
          break;
        case '1':
          taskColor = 'orange';
          break;
        case '2':
          taskColor = 'blue';
          break;
        case '3':
          taskColor = 'red';
          break;
        default:
          break;
      }

      const newTask = {
        id: taskId.trim() == '' ? md5('') : taskId,
        bf_task_id: taskId,
        // text: typeof eachTask.taskName !== 'undefined' ? eachTask.taskName : '',
        name: typeof eachTask.taskName !== 'undefined' ? eachTask.taskName : '',
        $level: level,
        parent: parent,
        disabled,
        color: taskColor,
        start_date: '',
        end_date: '',
        duration: 0,
        unscheduled: disabled,
      };

      if (!disabled) {
        newTask.start_date = start_date_text || end_date_text;
        newTask.end_date = end_date_text || start_date_text;
        newTask.duration = eachTask.duration || '';
        newTask.progress = 0;
      }
      return newTask;
    }

    const newTask = {
      id: taskId.trim() == ''
          ? md5('')
          : taskId + (parent !== null ? parent : ''),
      // text: typeof eachTask.taskName !== 'undefined' ? eachTask.taskName : '',
      name: typeof eachTask.taskName !== 'undefined' ? eachTask.taskName : '',
      $level: level,
      start_date: start_date_text || end_date_text,
      end_date: end_date_text || start_date_text,
      unscheduled: disabled,
      duration: 0,
      progress: 0,
    };

    if (parent !== null) {
      newTask['parent'] = parent;
    }

    return newTask;
  }

  createGanttDataByEmployees(result) {
    // this.sortDataByWorkState(result.data, result.work_state)
    const carRegMap = {};
    const responseMap = {};
    const subTasks = [];
    result.data.forEach((customer, cid) => {
      const customerName = customer.company;
      customer.worklist.forEach((work, wid) => {
        const car_registration_no = work.car_registration_no;
        work.tasklist.forEach((task) => {
          const lvl_0_id = task.responsible_name;
          const responsiblePersonTask =
              // typeof responseMap[task.responsible_name] !== 'undefined'
              (task.responsible_name in responseMap)
                  ? responseMap[task.responsible_name]
                  : this.createPersonTask(lvl_0_id, 0, null,
                  {taskName: task.responsible_name});
          if (!(task.responsible_name in responseMap))
            responseMap[task.responsible_name] = responsiblePersonTask;
          const carReg = `${task.responsible_name}${car_registration_no}(${customerName})`;
          const lvl_1_id = [
            responsiblePersonTask.id,
            `${car_registration_no}(${customerName})`].join('-');
          const carRegTask = (carReg in carRegMap)
              ? carRegMap[carReg]
              : this.createPersonTask(lvl_1_id, 1, responsiblePersonTask.id,
                  {taskName: `${car_registration_no}(${customerName})`},
              );

          if (!(carReg in carRegMap)) {
            carRegMap[carReg] = carRegTask;
            subTasks.push(carRegTask);
          }
          task.tasklist.forEach((eachTask) => {
            const lvl_2_id = [carRegTask.id, eachTask.taskName].join('-');
            subTasks.push(
                this.createPersonTask(lvl_2_id, 2, carRegTask.id, eachTask),
            );
          });
        });
      });
    });
    const allTasks = subTasks.concat(Object.values(responseMap));
    const links = this.createLinks(allTasks, result.work_state);
    this.setState(
        {
          workdocFixingPlanList: result.data,
          workState: result.work_state,
          task: allTasks,
          links: links,
          maxLevel: 2,
          loading: false,
        },
        () => this.applyFilter(),
    );
  }

  setTaskByResponsiblePerson() {
    WorkdocStore.loadWorkdocFixingPlanList2((result) => {
      this.createGanttDataByEmployees(result);
      // console.log('allTasks', allTasks)
    });
  }

  setWorkerViewTaskByEmployeeId(employeeId) {
    WorkdocStore.loadWorkdocFixingPlanListByEmployeeId(employeeId, (result) => {
      this.createGanttDataByEmployees(result);
      // console.log('allTasks', allTasks)
    });
  }

  setWorkerViewTaskByContractorId(contractorId) {
    WorkdocStore.loadWorkdocFixingPlanListByContractorId(contractorId,
        (result) => {
          this.createGanttDataByEmployees(result);
          // console.log('allTasks', allTasks)
        });
  }

  setCompanyViewTaskByContractorId = async (contractorId) => {
    try {
      const {data, work_state} = await WorkdocStore.loadWorkdocFixingPlanList2ByContractorId(
          contractorId);
      // console.log(tasks, 'tasks from fuck')
      // const links = await axios.get('/link')
      // const templates = await axios.get('/template')
      // const holders = await axios.get('/holder')
      // const sample = {id: 3, name: 'Task #2',holder:'test',$level:3,parent:2, start_date: '18-04-2017', duration: 3, progress: 0.4}

      this.createGanttDataByCompany(data, work_state);
      // this.setState({ task: tasks.data, links: links.data, task_template: templates.data, holders: holders.data, pageMounted: true })
    } catch (err) {
      console.error(err, 'error from getData');
    }
  };

  setCompanyViewTaskByEmployeeId = async (employeeId) => {
    try {
      const {data, work_state} = await WorkdocStore.loadWorkdocFixingPlanList2ByEmployeeId(
          employeeId);
      // console.log(tasks, 'tasks from fuck')
      // const links = await axios.get('/link')
      // const templates = await axios.get('/template')
      // const holders = await axios.get('/holder')
      // const sample = {id: 3, name: 'Task #2',holder:'test',$level:3,parent:2, start_date: '18-04-2017', duration: 3, progress: 0.4}

      this.createGanttDataByCompany(data, work_state);
      // this.setState({ task: tasks.data, links: links.data, task_template: templates.data, holders: holders.data, pageMounted: true })
    } catch (err) {
      console.error(err, 'error from getData');
    }
  };

  updateGantt() {
    if (typeof this.gantt !== 'undefined') {
      console.log('updateGantt');
      this.gantt.updateIcon();
      this.gantt.parseTasks();
      this.gantt.sortTask();
    }
  }

  getMockData() {
    let taskMock = [
      {
        id: 'นริน',
        isCompany: true,
        name: 'บริษัท',
        holder: 'กข',
        $level: 0,
        start_date: '15-04-2017',
        duration: 3,
        progress: 0.6,
      },
      {
        id: 23434,
        name: 'level1',
        holder: 'test',
        $level: 1,
        parent: 'นริน',
        start_date: '18-04-2017',
        duration: 3,
        progress: 0.4,
      },
      {
        id: 3,
        name: 'level2',
        holder: 'test',
        $level: 2,
        parent: 23434,
        start_date: '18-04-2017',
        duration: 3,
        progress: 0.4,
      },
      {
        id: 'เนส',
        color: 'red',
        isCompany: true,
        name: 'Task #1',
        holder: 'กข',
        $level: 0,
        start_date: '15-04-2017',
        duration: 3,
        progress: 0.6,
      },
      {
        id: 34343,
        color: 'red',
        name: 'Task #2',
        holder: 'test',
        $level: 2,
        parent: 'เนส',
        start_date: '18-04-2017',
        duration: 3,
        progress: 0.4,
      },
      {
        id: 12323,
        color: 'red',
        name: 'เนสฟัก',
        holder: 'test',
        $level: 3,
        parent: 3,
        start_date: '18-10-2017',
        duration: 3,
        progress: 0.4,
      },
    ];
    this.setState({task: taskMock});
  }

  getMockDataX() {
    let taskMock = {
      'companyName':
          [
            {
              'A':
                  {
                    'time': '12.00',
                    'date': '02/04/17',
                    'subTask': [
                      {
                        'deliveryTime': '15.00',
                        'deliveryDate': '02/04/17',
                        'title': 'test',
                        'duration': 13,
                        'carID': 'กท-1234',
                        'contract': 'test',
                        'type': 'บริษัท',
                      },
                    ],
                  },
            },
          ],
    };
    this.setState({task: taskMock});
  }

  reload() {
    //Do nothing
  }

  addMessage(message) {
    var messages = this.state.messages.slice();
    var prevKey = messages.length
        ? messages[0].key
        : 0;

    messages.unshift({
      key: prevKey + 1,
      message,
    });
    if (messages.length > 40) {
      messages.pop();
    }
    this.setState({messages});
  }

  createTask = (task) => {
    const {
      id,
      holder,
      name,
      description,
      start_date,
      duration_amount,
      parent,
      template,
    } = task;
    const filterTemplate = this.state.task_template.filter(
        (d) => d.name === template);
    const filteredTemplate = filterTemplate[0];
    const data = {
      name: name,
      description: description,
      holder: holder,
      duration: duration_amount,
      start_date: moment(start_date).format('DD-MM-YYYY'),
      template: template,
      color: filteredTemplate.color,
      id: id,
      parent: parent,
    };
    axios.post('/task', data).
        then(res => this.getData()).
        catch(err => console.error(err));
  };
  updateTask = (task) => {
    const {
      _id,
      id,
      description,
      holder,
      duration,
      duration_amount,
      start_date,
      template,
      color,
      parent,
      progress,
    } = task;
    let duration_val = duration;
    if (duration_amount) duration_val = duration_amount;
    const data = {
      id,
      description,
      holder,
      duration: duration_val,
      start_date: moment(start_date).format('DD-MM-YYYY'),
      template,
      color,
      parent,
      progress,
    };
    axios.post(`/task/${id}`, data).
        then(res => this.getData()).
        catch(err => console.error(err));
  };
  removeTask = (id) => {
    axios.delete(`/task/${id}`).
        then(res => this.getData()).
        catch(err => console.error(err));
  };
  onTaskUpdated = (id, mode, task) => {
    switch (mode) {
      case 'inserted':
        this.createTask(task);
        break;
      case 'updated':
        this.updateTask(task);
        break;
      case 'deleted':
        this.removeTask(id);
        break;
      default:
        break;
    }
  };

  createLink = (link) => {
    axios.post(`/link`, link).
        then(res => res.data).
        then(links => this.setState({links})).
        catch(err => console.error(err));
  };
  updateLink = (id, link) => {
    axios.post(`/link/${id}`, link).
        then(res => this.getData()).
        catch(err => console.error(err));
  };
  deleteLink = (id) => {
    axios.delete(`/link/${id}`).
        then(res => this.getData()).
        catch(err => console.error(err));
  };

  onLinkUpdated = (id, mode, link) => {
    switch (mode) {
      case 'inserted':
        this.createLink(link);
        break;
      case 'updated':
        this.updateLink(id, link);
        break;
      case 'deleted':
        this.deleteLink(id);
        break;
      default:
        break;
    }
  };

  handleZoomChange = (zoom) => {
    this.setState({currentZoom: zoom});
  };

  handleAddTask() {
    this.setState({
      task: [
        ...this.state.task, {
          id: this.state.task.length,
          text: 'Task #3',
          start_date: '18-04-2017',
          duration: 5,
          progress: 0.4,
        },
      ],
    });
  }

  showCompanyModal = () => {
    this.setState({
      showCompanyModal: !this.state.showCompanyModal,
    });
  };

  getGrandParents(newTask) {
    // const qParams = Array(this.props.newTask.$level * 1).
    const qParams = Array(newTask.$level * 1).
        fill(0).reduce((acc, title, level) => {
              const parentId = acc.child.parent;
              const parent = this.state.task.filter(
                  (task) => task.$level * 1 >= 0 && task.id === parentId,
              )[0];
              acc.parents = acc.parents.concat(parent.name);
              acc.child = parent;
              return acc;
            }, {
              parents: [],
              child: newTask,
            },
        );
    return qParams.parents.reverse();
  }

  getQueryParamsOfWorkerView(newTask) {
    const params = this.getGrandParents(newTask);
    return {
      responsible_name: typeof params[0] !== 'undefined' ? params[0] : '',
      car_registration_no: typeof params[1] !== 'undefined' ? params[1] : '',
    };
  }

  getQueryParamsOfCustomerView(newTask) {
    const params = this.getGrandParents(newTask);
    return {
      company: typeof params[0] !== 'undefined' ? params[0] : '',
      car_registration_no: typeof params[1] !== 'undefined' ? params[1] : '',
      responsible_name: typeof params[2] !== 'undefined' ? params[2] : '',
    };
  }

  sortFunc = (a, b) => {
    if (a.$level !== this.state.maxLevel) return;

    const getTaskIndex = (name) =>
        this.state.workState.findIndex((ele) => ele.label === name);
    const aIndex = getTaskIndex(a.name);
    const bIndex = getTaskIndex(b.name);
    return (
        aIndex > bIndex
            ? 1 : (aIndex < bIndex ? -1 : 0)
    );
  };

  onBeforeTaskDisplay = (id, task) => {
    // console.log('before-task-display', id, task);
    // return this.state.filter_ids.indexOf(task.id) !== -1;
    return true;
  };

  onPageChange = (field) => value => {
    let new_state = {
      [field]: value,
    };

    if (field === 'page_limit') {
      new_state.page = 1;
    }

    this.setState(new_state, () => this.applyFilter());
  };

  renderGantt() {
    const {links, task, data = []} = this.state;
    console.log('renderGantt=>',data)
    return (<Gantt
        ref={(ele) => { this.gantt = ele; }}
        tasks={{
          // data: JSON.parse(JSON.stringify(this.state.task)),
          data,
          links,
        }}
        // tasks={{
        //   data: data.data,
        //   links: data.links
        // }}
        // workState={this.state.workState}
        //   filter_date={this.state.filter_date}
        sortFunc={this.sortFunc}
        maxLevel={this.state.maxLevel}
        zoom={this.state.currentZoom}
        onTaskUpdated={this.onTaskUpdated}
        onLinkUpdated={this.onLinkUpdated}
        task_template={this.state.task_template}
        holders={this.state.holders}
        showTemplateModal={this.showTemplateModal}
        holderModalStatus={this.state.showHolderModal}
        showEditCompanyModal={this.showEditCompanyModal}
        showHolderModal={this.showHolderModal}
        onShowAddTaskModal={this.onShowAddTaskModal}
        onShowEditTaskModal={this.onShowEditTaskModal}
        onBeforeTaskDisplay={this.onBeforeTaskDisplay}
        onDragTask={this.onDragTask}
        onResizeTask={this.onResizeTask}
        onGanttInit={this.onGanttInit}
    />);
  }

  onShowEditTaskModal = (task, parentOfTaskId) => {
    this.setState((prevState) => {
      let copied = {...prevState.editTaskModal};
      // copied.newTask = task
      copied.bf_task_id = task.bf_task_id;
      if (this.state.maxLevel === 3 && task.$level === 3) {
        const parentValues = this.getQueryParamsOfCustomerView(task);
        copied.latestSelectedId = parentOfTaskId;

        copied.companyView.company = parentValues.company;
        copied.companyView.car_registration_no = parentValues.car_registration_no;
        copied.companyView.responsible_name = parentValues.responsible_name;
        const selectedTask =
            this.getTaskForEditTaskModal(
                parentValues.company,
                parentValues.car_registration_no,
                task.bf_task_id,
            );

        copied.companyView.taskName = task.name;
        copied.companyView.taskValue = selectedTask.tasklist[0].taskValue;
        copied.companyView.start_date = selectedTask.tasklist[0].startDate;
        const end =
            moment(selectedTask.tasklist[0].startDate, 'DD/MM/YYYY').
                add(task.duration * 1, 'days').
                format('DD/MM/YYYY');
        copied.companyView.end_date = end;
        // copied.companyView.end_date = selectedTask.endDate
        if (parentValues.responsible_name !== '')
          return {
            showEditTaskModal: !prevState.showEditTaskModal,
            editTaskModal: copied,
          };
      } else if (this.state.maxLevel === 2 && task.$level === 2) {
        const parentValues = this.getQueryParamsOfWorkerView(task);
        copied.latestSelectedId = parentOfTaskId;

        copied.workerView.car_registration_no = parentValues.car_registration_no;
        copied.workerView.responsible_name = parentValues.responsible_name;
        const selectedTask =
            this.getTaskForWorkerViewEditTaskModal(
                parentValues.car_registration_no, task.bf_task_id);

        copied.workerView.taskName = task.name;
        copied.workerView.taskValue = selectedTask.tasklist[0].taskValue;
        copied.workerView.start_date = selectedTask.tasklist[0].startDate;
        const end =
            moment(selectedTask.tasklist[0].startDate, 'DD/MM/YYYY').
                add(task.duration * 1, 'days').
                format('DD/MM/YYYY');
        copied.workerView.end_date = end;
        if (parentValues.responsible_name !== '')
          return {
            showEditTaskModal: !prevState.showEditTaskModal,
            editTaskModal: copied,
          };
      }
    });
  };

  onShowAddTaskModal = (newTask, parentOfNewTaskId) => {
    this.setState((prevState) => {
      let copied = {...prevState.addTaskModal};
      console.log('onShowAddTaskModal newTask', newTask);
      copied.newTask = newTask;
      if (this.state.maxLevel === 3) {
        const parentValues = this.getQueryParamsOfCustomerView(newTask);
        copied.latestSelectedId = parentOfNewTaskId;

        copied.companyView.company = parentValues.company;
        copied.companyView.car_registration_no = parentValues.car_registration_no;
        copied.companyView.responsible_name = parentValues.responsible_name;
      } else {
        const parentValues = this.getQueryParamsOfWorkerView(newTask);
        copied.latestSelectedId = parentOfNewTaskId;
        copied.workerView.car_registration_no = parentValues.car_registration_no;
        copied.workerView.responsible_name = parentValues.responsible_name;
      }

      return {
        showAddTaskModal: !prevState.showAddTaskModal,
        addTaskModal: copied,
      };
    });
  };

  getItemWithParent(_filter_items) {

    let filter_items = [..._filter_items];
    let level = this.state.maxLevel;
    while (level > 0) {

      const parent_ids = _.map(
          _.filter(filter_items, i => i.$level == parseInt(level)),
          i => i.parent);
      level--;
      filter_items = [
        ...filter_items,
        ..._.filter(this.state.task, i => {
          return i.$level == level && parent_ids.indexOf(i.id) !== -1;
        }),
      ];
    }

    return filter_items;
  }

  getChildrenItems(_filter_items) {
    const maxLevel = parseInt(this.state.maxLevel);
    if (_.every(_filter_items, i => i.$level === maxLevel)) {
      return _filter_items;
    }

    let filter_items = _.filter(_filter_items,
        i => i.$level == maxLevel);
    let parent_items = _.filter(_filter_items,
        i => i.$level != maxLevel);

    _.each(parent_items, i => {
      filter_items = [
        ...filter_items,
        ..._.filter(this.state.task, item => {
          return item.parent === i.id;
        })];
    });

    return _.uniqBy(this.getChildrenItems(filter_items), 'id');
  }

  getFilterByKeyword(tasks, keyword) {
    if (!keyword) {
      return tasks;
    }
    return _.filter(tasks, i => {
      return i.name.indexOf(keyword) !== -1;
    });
  }

  onKeywordChange = (keyword) => {

    // let filter_items = this.getFilterByKeyword(keyword);
    //
    // const filter_ids = _.map(this.getItemWithParent(filter_items), i => i.id);
    this.setState({keyword}, () => this.applyFilter());
  };

  getFilterData() {
    const items = _.filter(this.state.task, i => {
      return i.$level == this.state.maxLevel;
    });
    return items;
  }

  applyFilter(state = this.state, applyState = true) {
    const {page, page_limit, task, keyword, maxLevel, links} = state;
    const start = (parseInt(page, 10) - 1) * parseInt(page_limit);
    const end = start + parseInt(page_limit);

    let keyword_items = task.filter(i => i.name.indexOf(keyword) !== -1);

    let filter_items = this.getChildrenItems(keyword_items).
        filter(i => i.$level == maxLevel).
        slice(start, end);

    const items = task.filter(i => i.$level == maxLevel);
    const page_num = Math.ceil(items.length / page_limit);
    const page_prev = start > 0;
    const page_next = end < items.length;
    const data = this.getItemWithParent(filter_items);
    const new_state = {data, page_prev, page_next, page_num, links};
    return new Promise((r, j) => {
      if (applyState === true) {
        this.setState(new_state, () => {
          this.updateGantt();
          r(new_state);
        });
      } else {
        r(new_state);
      }
    });
  }

  onSelectChange = (key, taskId, taskVal, maxLevel) => {
    this.setState((prevState) => {
      let copied = {...prevState.addTaskModal};

      if (maxLevel === 3) {
        copied.companyView[key] = taskVal;
        copied.latestSelectedId = taskId;
      } else if (maxLevel === 2) {
        copied.workerView[key] = taskVal;
        copied.latestSelectedId = taskId;
      }

      return {
        addTaskModal: copied,
      };
    });
  };

  showTemplateModal = () => {
    this.setState({
      showTemplateModal: !this.state.showTemplateModal,
    });
  };
  showHolderModal = () => {
    this.setState({
      showHolderModal: !this.state.showHolderModal,
    });
  };
  addNewTemplate = (data) => {
    const {color, name, maxDuration} = data;
    if (name.length === '' && color.length === '' && maxDuration === '') {
      alert('กรุณากรอกข้อมูลให้ครบ');
      return;
    }
    axios.post('/template', data).
        then(res => this.reload()).
        catch(err => console.error(err));
  };
  addNewHolder = (data) => {
    if (data === '') {
      alert('กรุณากรอกชื่อ');
      return;
    }
    axios.post('/holder', {name: data}).
        then(res => this.reload()).
        catch(err => console.error(err));
  };

  onSubmitCompany = (name) => {
    const id = md5(name) + new Date().getUTCMilliseconds(); // id of task can adjust by your self
    axios.post('/task', {id, name, isCompany: true, start_date: '11-08-2560'}).
        then(res => {
          this.getData();
          this.setState({showCompanyModal: false});
        }).
        catch(err => alert(err.message));
  };
  getCompanyData = (id) => {

  };
  showEditCompanyModal = (id) => {
    axios.get(`/task/${id}`).
        then(res => res.data).
        then(res => this.setState({
          companyDetails: res,
          showEditCompanyModal: !this.state.showEditCompanyModal,
        })).
        catch(err => alert(err.message));
  };

  updateCompany = (name, id) => {
    axios.post(`/task/${id}`, {name, isCompany: true}).
        then(res => this.getData()).
        then(() => this.setState({showEditCompanyModal: false})).
        catch(err => alert(err.message));
  };

  removeCompany = (id) => {
    axios.delete(`/task/${id}`).
        then(res => this.reload()).
        catch(err => console.error(err));
  };

  onDisplayOptionChanged = (key) => {
    // if (typeof this.gantt !== 'undefined')
    this.gantt.clearAll();
    this.setState((prevState) => {
      return {
        loading: true,
        maxLevel: key === 'customerName' ? 3 : 2,
      };
    }, () => this.updatePlanState(this.props));
  };

  getMetaForWorkerViewTaskSave(view) {
    const splitted = view.car_registration_no.split('(');
    const car_registration_no = splitted[0];
    const company = splitted[1].slice(0, splitted[1].length - 1);

    const companyObject =
        this.state.workdocFixingPlanList.filter(
            (obj) => obj.company === company)[0];

    const taskObject =
        companyObject.worklist.map((obj) => {
          if (obj.car_registration_no !== car_registration_no) return null;
          const selectedTask =
              obj.tasklist.filter((task) =>
                  task.responsible_name === view.responsible_name,
              )[0];
          return selectedTask;
        })[0];

    return {
      work_no: companyObject.worklist[0].work_no,
      contractor_id: taskObject.contractor_id,
      employee_id: taskObject.employee_id,
      leader_id: '',
      total_cost: '',
      bf_work_damage_id: 0,
    };
  }

  getMetaForTaskSave(view) {
    const companyObject =
        this.state.workdocFixingPlanList.filter(
            (obj) => obj.company === view.company)[0];

    const taskObject =
        companyObject.worklist.map((obj) => {
          if (obj.car_registration_no !== view.car_registration_no) return null;
          const selectedTask =
              obj.tasklist.filter((task) =>
                  task.responsible_name === view.responsible_name,
              )[0];
          return selectedTask;
        })[0];

    return {
      work_no: companyObject.worklist[0].work_no,
      contractor_id: taskObject.contractor_id,
      employee_id: taskObject.employee_id,
      leader_id: '',
      total_cost: '',
      bf_work_damage_id: 0,
    };
  }

  calculateDuration(startDate, endDate) {
    const mmEndDate = endDate !== ''
        ? moment(endDate, 'DD/MM/YYYY')
        : '';
    const mmStartDate = startDate !== ''
        ? moment(startDate, 'DD/MM/YYYY')
        : '';

    if (mmEndDate === '') return '1';
    const duration = moment.duration(
        mmEndDate.diff(moment(mmStartDate, 'DD/MM/YYYY')));
    return duration.asDays();
  }

  /* calculateDuration() {
    const endDate =
      this.state.maxLevel === 3 && this.state.addTaskModal.companyView.end_date !== ''
        ? moment(this.state.addTaskModal.companyView.end_date, 'DD/MM/YYYY')
        : this.state.maxLevel === 2 && this.state.addTaskModal.workerView.end_date !== ''
          ? moment(this.state.addTaskModal.workerView.end_date, 'DD/MM/YYYY')
          : ''

    const startDate =
      this.state.maxLevel === 3 && this.state.addTaskModal.companyView.start_date !== ''
        ? moment(this.state.addTaskModal.companyView.start_date, 'DD/MM/YYYY')
        : this.state.maxLevel === 2 && this.state.addTaskModal.workerView.start_date !== ''
          ? moment(this.state.addTaskModal.workerView.start_date, 'DD/MM/YYYY')
          : ''
    if (endDate === '') return '1'
    const duration = moment.duration(endDate.diff(moment(startDate, 'DD/MM/YYYY')));
    return duration.asDays() + 1
  } */

  getTaskListForTaskEdit(view) {
    return [
      {
        taskName: view.taskName,
        taskValue: view.taskValue,
        taskStatus: view.taskStatus === '' ? '0' : '',
        startDate: view.start_date,
        startTime: view.start_time,
        endDate: view.end_date,
        endTime: view.end_time,
        duration: this.calculateDuration(view.start_date, view.end_date),
      }];
  }

  getTaskListForTaskSave(view) {
    return [
      {
        taskName: view.taskName,
        taskValue: view.taskValue,
        taskStatus: view.taskStatus === '' ? '0' : '',
        startDate: view.start_date,
        startTime: view.start_time,
        endDate: view.end_date,
        endTime: view.end_time,
        duration: this.calculateDuration(view.start_date, view.end_date),
      }];
  }

  onDeleteTask = () => {
    const {editTaskModal} = this.state;
    this.setState((prevState) => {
      this.gantt.clearAll();
      return {
        showEditTaskModal: false,
        editTaskModal: JSON.parse(JSON.stringify(this.emptyEditTaskModal)),
        loading: true,
      };
    }, () => {
      WorkdocStore.delWorkdocFixingTask(editTaskModal.bf_task_id,
          (result) => {
            this.updatePlanState(this.props);
            // if (this.state.maxLevel === 3)
            //   this.getData()
            // else
            //   this.setTaskByResponsiblePerson()
          },
          (err) => { });
    });

  };

  getTaskModalForEdit(task, parentOfTaskId) {
    let copied = JSON.parse(JSON.stringify(this.state.editTaskModal));
    // Customer view
    copied.bf_task_id = task.bf_task_id;
    if (this.state.maxLevel === 3 && task.$level === 3) {
      const parentValues = this.getQueryParamsOfCustomerView(task);
      copied.latestSelectedId = parentOfTaskId;

      copied.companyView.company = parentValues.company;
      copied.companyView.car_registration_no = parentValues.car_registration_no;
      copied.companyView.responsible_name = parentValues.responsible_name;
      const selectedTask =
          this.getTaskForEditTaskModal(
              parentValues.company,
              parentValues.car_registration_no,
              task.bf_task_id,
              task.name,
          );

      copied.companyView.taskName = task.name;
      copied.companyView.taskValue = selectedTask.tasklist[0].taskValue;

      copied.companyView.start_date = this.gantt.getTaskDate(task.start_date);
      copied.companyView.end_date = this.gantt.getTaskDate(task.end_date);
      if (parentValues.responsible_name !== '')
        return copied;
    } else if (this.state.maxLevel === 2 && task.$level === 2) {
      const parentValues = this.getQueryParamsOfWorkerView(task);
      copied.latestSelectedId = parentOfTaskId;

      copied.workerView.car_registration_no = parentValues.car_registration_no;
      copied.workerView.responsible_name = parentValues.responsible_name;
      const selectedTask =
          this.getTaskForWorkerViewEditTaskModal(
              parentValues.car_registration_no, task.bf_task_id);

      copied.workerView.taskName = task.name;
      copied.workerView.taskValue = selectedTask.tasklist[0].taskValue;
      copied.workerView.start_date = this.gantt.getTaskDate(task.start_date);
      copied.workerView.end_date = this.gantt.getTaskDate(task.end_date);
      if (parentValues.responsible_name !== '')
        return copied;
    }
    return null;
  }

  submitTask2Edit(editTaskModal) {
    let postData = {};
    if (this.state.maxLevel === 3) {
      const meta = this.getMetaForTaskSave(editTaskModal.companyView);
      const tasklist = this.getTaskListForTaskEdit(editTaskModal.companyView);
      postData = {meta: meta, tasklist: tasklist};
    } else if (this.state.maxLevel === 2) {
      const meta = this.getMetaForWorkerViewTaskSave(editTaskModal.workerView);
      const tasklist = this.getTaskListForTaskEdit(editTaskModal.workerView);
      postData = {meta: meta, tasklist: tasklist};
    }
    if (postData !== {})
      this.setState((prevState) => {
        this.gantt.clearAll();
        return {
          loading: true,
          showEditTaskModal: false,
          editTaskModal: JSON.parse(JSON.stringify(this.emptyEditTaskModal)),
        };
      }, () => {
        WorkdocStore.saveWorkdocFixingTask(
            editTaskModal.bf_task_id,
            postData,
            (result) => {
              this.updatePlanState(this.props);
              // if (this.state.maxLevel === 3)
              //   this.getData()
              // else
              //   this.setTaskByResponsiblePerson()
            },
        );
      });
  }

  onResizeTask = (task, parentOfTaskId) => {
    const editTaskModal = this.getTaskModalForEdit(task, parentOfTaskId);
    this.submitTask2Edit(editTaskModal);
  };

  onDragTask = (task, parentOfTaskId) => {
    const editTaskModal = this.getTaskModalForEdit(task, parentOfTaskId);
    this.submitTask2Edit(editTaskModal);
  };

  onEditTask = () => {
    // this.gantt.addNewTask(newTask)
    const {editTaskModal} = this.state;
    this.submitTask2Edit(editTaskModal);
  };

  updatePlanState(theProps) {
    console.log('updatePlanState props', theProps);
    let {employeeId, contractorId} = theProps;
    console.log('employeeId', employeeId);
    console.log('contractorId', contractorId);
    if (this.state.maxLevel === 3) {
      if (typeof employeeId !== 'undefined')
        this.setCompanyViewTaskByEmployeeId(employeeId);
      else if (typeof contractorId !== 'undefined')
        this.setCompanyViewTaskByContractorId(contractorId);
      else
        this.getData();
      return;
    } else {
      if (typeof employeeId !== 'undefined')
        this.setWorkerViewTaskByEmployeeId(employeeId);
      else if (typeof contractorId !== 'undefined')
        this.setWorkerViewTaskByContractorId(contractorId);
      else this.setTaskByResponsiblePerson();
      return;
    }
  }

  setNewTask4GanttClientSide() {
    const view = this.state.maxLevel === 3
        ? this.state.addTaskModal.companyView
        : this.state.addTaskModal.workerView;
    const newTask = this.state.addTaskModal.newTask;
    console.log('setNewTask4GanttClientSide view', view);
    console.log('setNewTask4GanttClientSide', newTask);
    newTask.text = view.taskName;
    newTask.start_date = view.start_date;
    newTask.end_date = view.end_date;
    newTask.duration = this.calculateDuration(view.start_date, view.end_date);
    this.gantt.addNewTask(newTask);
  }

  onAddNewTask = () => {
    // this.gantt.addNewTask(newTask)
    const {addTaskModal} = this.state;
    let postData = {};
    if (this.state.maxLevel === 3) {
      const meta = this.getMetaForTaskSave(addTaskModal.companyView);
      const tasklist = this.getTaskListForTaskSave(addTaskModal.companyView);
      postData = {meta: meta, tasklist: tasklist};
    } else if (this.state.maxLevel === 2) {
      const meta = this.getMetaForWorkerViewTaskSave(addTaskModal.workerView);
      const tasklist = this.getTaskListForTaskSave(addTaskModal.workerView);
      postData = {meta: meta, tasklist: tasklist};
    }
    if (postData !== {}) {
      this.setState((prevState) => {
            this.gantt.clearAll();

            return {
              showAddTaskModal: false,
              loading: true,
              addTaskModal: JSON.parse(JSON.stringify(this.emptyAddTaskModal)),
            };
          },
          () => {
            WorkdocStore.saveWorkdocFixingTask('', postData, (result) => {
              this.updatePlanState(this.props);
              // this.setNewTask4GanttClientSide()
              // this.setState((prevState) => {
              //   return {
              //     loading: false
              //   }
              // })
            });
          },
      );
    }
  };

  onPrintRequest = e => {
    this.setState({showPrintModal: true});
  };

  onPrintSubmit = async (gantt_params, print_params) => {
    if (!this.ganttInstance) {
      console.error('gant not init');
      return false;
    }
    await new Promise((r, j) => {
      this.setState({loading: true}, () => setTimeout(r, 100));
    });

    const before_print_config = _.clone(this.ganttInstance.config);
    _.merge(this.ganttInstance.config, gantt_params);

    for (let i = print_params.start_page; i <= print_params.end_page; i++) {
      const data = await this.applyFilter({
        ...this.state, page: i,
      }, false);
      this.ganttInstance.parse(data);
      // continue;
      // const data = this.ganttInstance.serialize();
      data.data = data.data.map(item => {
        let map_item = {...item};
        map_item.text = item.name;
        if (item.unscheduled === true) {
          map_item = {
            ...map_item,
            unscheduled: true,
            start_date: null,
            end_date: null,
            color: null,
            duration: 0,
            progress: null,
          };
        } else {
          if (moment(item.start_date) < print_params.start_date) {
            map_item.unscheduled = true;
            map_item.start_date = print_params.start_date.format('DD-MM-YYYY');
            map_item.duration = '-';
          } else if (moment(item.start_date) > print_params.end_date) {
            map_item.unscheduled = true;
            map_item.start_date = print_params.end_date.format('DD-MM-YYYY');
            map_item.duration = '-';
          } else {
            map_item.start_date = moment(map_item.start_date).
                format('DD-MM-YYYY');
          }

          if (moment(item.end_date) > print_params.end_date) {
            map_item.unscheduled = true;
            map_item.end_date = print_params.end_date.format('DD-MM-YYYY');
            map_item.duration = '-';
          } else if (moment(item.end_date) < print_params.start_date) {
            map_item.unscheduled = true;
            map_item.end_date = print_params.start_date.format('DD-MM-YYYY');
            map_item.duration = '-';
          } else {
            map_item.end_date = moment(map_item.end_date).format('DD-MM-YYYY');
          }
        }
        return map_item;
      });

      console.log('print data page', i, data.data);
      // data.data = data.data.map(item => {
      //   const unscheduled = item.unscheduled === true
      //                       // || (
      //                       //     moment(item.start_date) <
      //                       //     print_params.start_date
      //                       //     && moment(item.end_date) >
      //                       //     print_params.end_date
      //                       // );
      //   return {
      //     ...item,
      //     text: item.name,
      //     start_date: unscheduled === true ? null : moment(item.start_date).
      //         format('DD-MM-YYYY'),
      //     end_date: unscheduled === true ? null : moment(item.end_date).
      //         format('DD-MM-YYYY'),
      //     color: unscheduled === true ? 'white' : item.color,
      //     duration: unscheduled === true ? null : item.duration,
      //     progress: unscheduled === true ? null : item.progress,
      //   };
      // });

      const export_config = _.merge({
        name: `plan-export-${i}.pdf`,
      }, {
        data,
        ...print_params,
      });
      // console.log('print submit with', this.ganttInstance.config,
      //     export_config);

      this.ganttInstance.exportToPDF(export_config);
      await new Promise((r, j) => {
        setTimeout(r, 500);
      });

    }

    this.ganttInstance.config = before_print_config;
    this.setState({showPrintModal: false, loading: false},
        () => this.applyFilter());
  };

  onGanttInit = instance => {
    console.log('gantt init', instance);
    this.ganttInstance = instance;

    this.setState({
      ..._.pick(instance.config, ['start_date', 'end_date']),
    });
  };

  onStartDateChange = (dateString, dateMoment) => {
    let copied = {...this.state.addTaskModal};
    if (this.state.maxLevel === 3) {
      copied.companyView.start_date =
          dateString !== ''
              ? momentHelper.convertThaiToWorldYear(dateString)
              : '';
      this.setState({addTaskModal: copied});
      return;
    }

    copied.workerView.start_date =
        dateString !== ''
            ? momentHelper.convertThaiToWorldYear(dateString)
            : '';
    this.setState({addTaskModal: copied});
  };

  onEndDateChange = (dateString, dateMoment) => {
    console.log('onEndDateChange');
    let copied = {...this.state.addTaskModal};
    if (this.state.maxLevel === 3) {

      copied.companyView.end_date =
          dateString !== ''
              ? momentHelper.convertThaiToWorldYear(dateString)
              : '';
      console.log('onEndDateChange level = 3', dateString);
      this.setState({addTaskModal: copied});
      return;
    }

    copied.workerView.end_date =
        dateString !== ''
            ? momentHelper.convertThaiToWorldYear(dateString)
            : '';
    this.setState({addTaskModal: copied});
  };

  onNewTaskChange = (taskName, taskValue) => {
    let copied = {...this.state.addTaskModal};
    if (this.state.maxLevel === 3) {
      this.state.addTaskModal.companyView.taskValue = taskValue;
      this.state.addTaskModal.companyView.taskName = taskName;
      this.setState({addTaskModal: copied});
      return;
    }
    this.state.addTaskModal.workerView.taskValue = taskValue;
    this.state.addTaskModal.workerView.taskName = taskName;
    this.setState({addTaskModal: copied});
  };

  onHideAddTaskModal = () => {
    if (typeof this.gantt === 'undefined') return;
    this.gantt.deleteTask(this.state.addTaskModal.newTask.id);
    this.setState({
      showAddTaskModal: false,
      addTaskModal: JSON.parse(JSON.stringify(this.emptyAddTaskModal)),
    });
  };

  onHideEditTaskModal = () => {
    if (typeof this.gantt === 'undefined') return;
    // this.gantt.deleteTask(this.state.newTask.id)
    this.setState({
      showEditTaskModal: false,
      editTaskModal: JSON.parse(JSON.stringify(this.emptyEditTaskModal)),
    });
  };

  renderAddTaskModal() {
    if (typeof this.gantt === 'undefined') return null;
    return (
        <AddTaskModal
            show={this.state.showAddTaskModal}
            onHide={this.onHideAddTaskModal}
            // newTask={this.state.newTask}
            maxLevel={this.state.maxLevel}
            workdocFixingPlanList={this.state.workdocFixingPlanList}
            allTasks={this.state.task}
            onAddNewTask={this.onAddNewTask}
            onSelectChange={this.onSelectChange}
            onStartDateChange={this.onStartDateChange}
            onEndDateChange={this.onEndDateChange}
            onNewTaskChange={this.onNewTaskChange}
            data={this.state.addTaskModal}
            // addNewTemplate={this.addNewTemplate}
            // showTemplateModal={this.showTemplateModal}
        />
    );
  }

  getTaskForWorkerViewEditTaskModal(the_car_registration_no, bf_task_id) {
    const splitted = the_car_registration_no.split('(');
    const car_registration_no = splitted[0];
    const company = splitted[1].slice(0, splitted[1].length - 1);
    const companyObject =
        this.state.workdocFixingPlanList.filter(
            (obj) => obj.company === company)[0];

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== car_registration_no) return null;
      const tasksByTaskId = obj.tasklist.filter(
          (task) => task.bf_task_id === bf_task_id);
      return tasksByTaskId[0];
    })[0];
  }

  getTaskForEditTaskModal(company, car_registration_no, bf_task_id) {
    const companyObject =
        this.state.workdocFixingPlanList.filter(
            (obj) => obj.company === company)[0];

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== car_registration_no) return null;
      const tasksByTaskId = obj.tasklist.filter(
          (task) => task.bf_task_id === bf_task_id);
      return tasksByTaskId[0];
    })[0];
  }

  onEditTaskStartDateChange = (dateString, dateMoment) => {
    console.log('onEditTaskStartDateChange', dateString);
    let copied = {...this.state.editTaskModal};
    if (this.state.maxLevel === 3) {
      copied.companyView.start_date =
          dateString !== ''
              ? momentHelper.convertThaiToWorldYear(dateString)
              : '';
      this.setState({editTaskModal: copied});
      return;
    }

    copied.workerView.start_date =
        dateString !== ''
            ? momentHelper.convertThaiToWorldYear(dateString)
            : '';
    this.setState({editTaskModal: copied});
  };

  onEditTaskEndDateChange = (dateString, dateMoment) => {
    console.log('onEditTaskEndDateChange', dateString);
    let copied = {...this.state.editTaskModal};
    if (this.state.maxLevel === 3) {
      copied.companyView.end_date =
          dateString !== ''
              ? momentHelper.convertThaiToWorldYear(dateString)
              : '';
      this.setState({editTaskModal: copied});
      return;
    }

    copied.workerView.end_date =
        dateString !== ''
            ? momentHelper.convertThaiToWorldYear(dateString)
            : '';
    this.setState({editTaskModal: copied});
  };

  renderEditTaskModal() {
    if (typeof this.gantt === 'undefined') return null;
    return (
        <EditTaskModal
            show={this.state.showEditTaskModal}
            onHide={this.onHideEditTaskModal}
            selectedTask={this.state.newTask}
            maxLevel={this.state.maxLevel}
            // workdocFixingPlanList={this.state.workdocFixingPlanList}
            // allTasks={this.state.task}
            onEditTask={this.onEditTask}
            onDeleteTask={this.onDeleteTask}
            // onSelectChange={this.onSelectChange}
            onStartDateChange={this.onEditTaskStartDateChange}
            onEndDateChange={this.onEditTaskEndDateChange}
            // onNewTaskChange={this.onNewTaskChange}
            data={this.state.editTaskModal}
            // addNewTemplate={this.addNewTemplate}
            // showTemplateModal={this.showTemplateModal}
        />
    );
  }

  getDataRange() {

    let start_date = _.min(_.map(this.state.data, 'start_date'));
    let end_date = _.max(_.map(this.state.data, 'end_date'));

    return {
      start_date: moment(start_date).
          startOf('week').
          add(1, 'day').
          format('YYYY-MM-DD'),
      end_date: moment(end_date).
          endOf('week').
          add(1, 'day').
          format('YYYY-MM-DD'),
    };
  }

  render() {
    const gantt = this.state.task.length > 0
        ? this.renderGantt()
        : null;
    return (
        <Box loading={this.state.loading}>
          <Box.Body>
            <div>
              <Toolbar
                  {..._.pick(this.state, [
                    'page',
                    'page_limit',
                    'keyword',
                    'page_prev',
                    'page_next'])}
                  onKeywordChange={this.onKeywordChange}
                  onPageChange={this.onPageChange('page')}
                  onPageLimitChange={this.onPageChange('page_limit')}
                  zoom={this.state.currentZoom}
                  onZoomChange={this.handleZoomChange}
                  showCompanyModal={this.showCompanyModal}
                  displayOptions={
                    [
                      {key: 'customerName', value: 'ลูกค้า'},
                      {key: 'responsibleName', value: 'ช่าง'},
                    ]
                  }
                  onPrintRequest={this.onPrintRequest}
                  onDisplayOptionChanged={this.onDisplayOptionChanged}
              />
              <div className="gantt-container">
                {gantt}
              </div>
              {this.renderAddTaskModal()}
              {this.renderEditTaskModal()}

              <TemplateModal
                  show={this.state.showTemplateModal}
                  addNewTemplate={this.addNewTemplate}
                  showTemplateModal={this.showTemplateModal}
              />
              <HolderModal
                  show={this.state.showHolderModal}
                  addNewHolder={this.addNewHolder}
                  showHolderModal={this.showHolderModal}
              />
              <CompanyModal
                  show={this.state.showCompanyModal}
                  submit={this.onSubmitCompany}
                  showCompanyModal={this.showCompanyModal}
              />
              <EditCompanyModal
                  show={this.state.showEditCompanyModal}
                  submit={this.updateCompany}
                  remove={this.removeCompany}
                  data={this.state.companyDetails}
                  showEditCompanyModal={this.showEditCompanyModal}
              />
              <PrintModal
                  {...this.getDataRange()}
                  {..._.pick(this.state,
                      ['maxLevel', 'zoom', 'page', 'page_limit', 'page_num'])}
                  show={this.state.showPrintModal}
                  start_page={this.state.page}
                  end_page={this.state.page_num}
                  onPrintCancel={() => this.setState({showPrintModal: false})}
                  onPrintSubmit={this.onPrintSubmit}
              />
            </div>
          </Box.Body>
        </Box>
    );
  }

}

export default Plan;



// WEBPACK FOOTER //
// ./src/view/workdoc/plan/Plan.js